import React from "react";

import RowWrapper from "./bootstrap/RowWrapper.jsx";

import { documentSort } from "../../util/sort.js";

export default function ContractDocuments({ documents, showAllDocuments }) {
  if (!showAllDocuments) {
    documents = documents.sort(documentSort).slice(0, 5);
  }
  return (
    <div className="panel-body">
      {documents.map(({ chContractDocumentSeq, contractModNumber, modDesc, effectiveDate, savedFileName }) =>
        contractModNumber > 0 ? (
          <RowWrapper key={chContractDocumentSeq}>
            <div className="col-sm-5">{`Mod # ${contractModNumber} - ${modDesc}`}</div>
            <div className="col-sm-4">
              {`Effective Date:  ${new Date(effectiveDate).toLocaleDateString(undefined, {
                dateStyle: "long",
              })}`}
            </div>
            <div className="col-sm-3">
              <a target="_blank" href={`/documents/${savedFileName}`}>
                Download PDF
              </a>
            </div>
          </RowWrapper>
        ) : (
          <RowWrapper key={chContractDocumentSeq}>
            <div className="col-sm-5">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {modDesc}
            </div>
            <div className="col-sm-4">
              {`Effective Date:  ${new Date(effectiveDate).toLocaleDateString(undefined, {
                dateStyle: "long",
              })}`}
            </div>
            <div className="col-sm-3">
              <a target="_blank" href={`/documents/${savedFileName}`}>
                Download PDF
              </a>
            </div>
          </RowWrapper>
        )
      )}
    </div>
  );
}
